<template>
  <div>
    <div class="content-header">先生名：{{ currentBillingTeacherName }}</div>
    <div class="content-body">
      <input type="radio" class="body-radio" id="billable" value="billable" v-model="billingDetail.status" />
      <label class="body-radio" for="billable">請求対象</label>
    </div>
    <div class="content-body">
      <input type="radio" class="body-radio" id="unbillable" value="unbillable" v-model="billingDetail.status" />
      <label class="body-radio" for="unbillable">請求対象外</label>
    </div>
    <div class="content-body">
      <input type="radio" class="body-radio" id="free_trial" value="free_trial" v-model="billingDetail.status" />
      <label class="body-radio" for="free_trial">初月無料</label>
    </div>
  </div>
</template>

<script>
import { basicTeacherNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    billingDetail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentBillingTeacherName() {
      if (this.billingDetail) {
        return basicTeacherNameIdPresent(this.billingDetail);
      }
      return '';
    },
  },
};
</script>

<style scoped>
.content-header {
  margin-left: 10px;
  margin-bottom: 15px;
}
.content-body {
  margin-left: 10px;
  margin-bottom: 10px;
}
.body-radio {
  margin-right: 5px;
}
</style>
